import { toggleMark } from "prosemirror-commands";
import { icons, MenuItem, menuBar } from "prosemirror-menu";

import { markActive, addLink } from "./common";

function addOptions(options, [key, value]) {
    options[key] = value;
    return options;
}

function cmdItem(cmd, options) {
    const menuOptions = Object.entries(options).reduce(addOptions, {
        label: options.title,
        run: cmd,
    });

    if ((!options.enable || options.enable === true) && !options.select)
        menuOptions[options.enable ? "enable" : "select"] = cmd;

    return new MenuItem(menuOptions);
}

function markItem(markType, options) {
    const menuOptions = Object.entries(options).reduce(addOptions, {
        active: markActive(markType),
        enable: true,
    });
    const mark = toggleMark(markType);
    return cmdItem(mark, menuOptions);
}

export default function getMenu(settings, schema) {
    const inlineMenu = [];

    const toggleStrong = markItem(schema.marks.strong, {
        title: "Toggle strong style",
        icon: icons.strong,
    });
    const toggleEm = markItem(schema.marks.em, { title: "Toggle emphasis", icon: icons.em });

    inlineMenu.push(toggleStrong);
    inlineMenu.push(toggleEm);

    if (settings.enableLinks) {
        const markType = schema.marks.link;
        const toggleLink = new MenuItem({
            title: "Add or remove link",
            icon: icons.link,
            active(state) {
                return markActive(state, markType);
            },
            enable(state) {
                return !state.selection.empty;
            },
            run: addLink(markType),
        });
        inlineMenu.push(toggleLink);
    }

    const fullMenu = [inlineMenu];

    const renderedMenu = menuBar({ floating: false, content: fullMenu });
    return renderedMenu;
}
